import { Skeleton } from '@/components/Skeleton';
import { useVIP } from '@/modules/vip/hooks';
import { useGetCommonStore } from '@/store';
import { VipTransferFormCard } from './components/VipTransferFormCard';
import { VipTransferGuestCard } from './components/VipTransferGuestCard';
import { VipUserCard } from './components/VipUserCard';
import { ScVipTransferCardFactory } from './styled';

enum VIP_TRANSFER_CARD_TYPE {
  GUEST = 'guest',
  VIP = 'vip',
  TRANSFER = 'transfer',
}

export const VipTransferCardFactory = () => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();
  const { isVip, isLoading } = useVIP();

  const getCardType = (): VIP_TRANSFER_CARD_TYPE => {
    if (user) {
      if (isVip) return VIP_TRANSFER_CARD_TYPE.VIP;
      return VIP_TRANSFER_CARD_TYPE.TRANSFER;
    }
    return VIP_TRANSFER_CARD_TYPE.GUEST;
  };

  const cardType = getCardType();

  const cardByType: Record<VIP_TRANSFER_CARD_TYPE, () => JSX.Element> = {
    [VIP_TRANSFER_CARD_TYPE.GUEST]: () => <VipTransferGuestCard />,
    [VIP_TRANSFER_CARD_TYPE.VIP]: () => <VipUserCard />,
    [VIP_TRANSFER_CARD_TYPE.TRANSFER]: () => <VipTransferFormCard />,
  };

  if (user && isLoading) {
    return (
      <ScVipTransferCardFactory>
        <Skeleton.Container flexDirection="column" gap={16}>
          <Skeleton.Rect height={24} rounded width="60%" />
          <Skeleton.Rect height={120} rounded />
          <Skeleton.Rect height={48} rounded />
        </Skeleton.Container>
      </ScVipTransferCardFactory>
    );
  }

  return (
    <ScVipTransferCardFactory>
      {cardByType[cardType]()}
    </ScVipTransferCardFactory>
  );
};
